import { cloneDeep, omit } from 'lodash-es';
import { IHeadlineLineItemBreakdown, IHeadlineLineItemBreakdownAccommodationLineItem, IHeadlineLineItemBreakdownFrontend } from 'services/BookingManagerApi';

export const convertHeadlineLineItemBreakdownToFrontendFormat = (headlineLineItemBreakdown: IHeadlineLineItemBreakdown): IHeadlineLineItemBreakdownFrontend => {
  const accommodationItems = headlineLineItemBreakdown.Accommodation.items;
  const hashedAccommodationItems: { [key: string]: IHeadlineLineItemBreakdownAccommodationLineItem & { order: number } } = accommodationItems.reduce((acc, cur, index) => {
    acc[cur.uuid] = { ...cur, order: index };
    return acc;
  }, {});
  const headlineLineItemBreakdownCopy = cloneDeep(headlineLineItemBreakdown);
  const newHeadlineLineItemBreakdown: IHeadlineLineItemBreakdownFrontend = {
    ...headlineLineItemBreakdownCopy,
    Accommodation: {
      ...headlineLineItemBreakdownCopy.Accommodation,
      items: hashedAccommodationItems,
    }
  };
  return newHeadlineLineItemBreakdown;
}

export const convertHeadlineLineItemBreakdownToBackendFormat = (headlineLineItemBreakdown: IHeadlineLineItemBreakdownFrontend): IHeadlineLineItemBreakdown => {
  const accommodationItems = headlineLineItemBreakdown.Accommodation.items;
  const values = Object.values(accommodationItems);
  const orderedAccommodationItems = values.reduce((acc, cur) => {
    acc[cur.order] = omit(cur, 'order');
    return acc;
  }, { length: values.length });
  const headlineLineItemBreakdownCopy = cloneDeep(headlineLineItemBreakdown);
  const newHeadlineLineItemBreakdown: IHeadlineLineItemBreakdown = {
    ...headlineLineItemBreakdownCopy,
    Accommodation: {
      ...headlineLineItemBreakdownCopy.Accommodation,
      items: Array.from(orderedAccommodationItems),
    }
  };
  return newHeadlineLineItemBreakdown;
}